import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { deleteTokens } from '../api/jwtAuth/jwtAuthApi';

export const useLogout = () => {
  const { logout } = useAuth();

  const history = useHistory();

  return useCallback(() => {
    deleteTokens().then(() => {
      logout();
      history.push('/');
    });
  }, [logout, history]);
};
